/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TaskInResultResponse model module.
 * @module model/TaskInResultResponse
 * @version 2.8.0
 */
class TaskInResultResponse {
    /**
     * Constructs a new <code>TaskInResultResponse</code>.
     * @alias module:model/TaskInResultResponse
     * @param creationDate {String} 
     * @param resultDate {String} 
     * @param result {Array.<Object>} 
     */
    constructor(creationDate, resultDate, result) { 
        
        TaskInResultResponse.initialize(this, creationDate, resultDate, result);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, creationDate, resultDate, result) { 
        obj['creationDate'] = creationDate;
        obj['resultDate'] = resultDate;
        obj['result'] = result;
    }

    /**
     * Constructs a <code>TaskInResultResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TaskInResultResponse} obj Optional instance to populate.
     * @return {module:model/TaskInResultResponse} The populated <code>TaskInResultResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TaskInResultResponse();

            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('resultDate')) {
                obj['resultDate'] = ApiClient.convertToType(data['resultDate'], 'String');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * @member {String} creationDate
 */
TaskInResultResponse.prototype['creationDate'] = undefined;

/**
 * @member {String} resultDate
 */
TaskInResultResponse.prototype['resultDate'] = undefined;

/**
 * @member {Array.<Object>} result
 */
TaskInResultResponse.prototype['result'] = undefined;






export default TaskInResultResponse;

